import { c as _c } from "react/compiler-runtime";
import { FaroBulkDialog } from "@components/common/faro-table/bulk-dialog/bulk-dialog";
import { BulkSuccessDialog } from "@components/common/faro-table/bulk-dialog/bulk-success-dialog";
import { getBulkActionButtonConfig } from "@components/common/faro-table/bulk-actions/bulk-actions-config";
import { FaroTextButton } from "@components/common/faro-text-button";
import { useRemoveMemberFromTeamsBulkDialogContent } from "@components/table/teams/bulk-actions/bulk-remove-member-from-teams-helper";
import { DeleteIcon, Text } from "@flat-ui";
import { useBulkActionsMode } from "@hooks/use-bulk-actions-mode";
import { TEAM_DISPLAY_NAME } from "@src/constants/team-constants";
import { useAppDispatch, useAppSelector } from "@store/store-helper";
import { bulkActionNameSelector, selectedEntitiesSelector, shouldShowSuccessDialogSelector } from "@store/table/table-selector";
import { setBulkActionName } from "@store/table/table-slice";
import { removeMembersFromTeam } from "@store/teams/teams-slice-thunk";
import { BulkActionEvents } from "@utils/track-event/track-event-list";
import { useEffect, useState } from "react";
/**
 * Shows a "Remove" bulk button that removes the given member from all the
 * selected teams. It opens a confirmation dialog explaining that the member
 * will lose access to the projects and workspace roles tied to those teams.
 */
export function BulkRemoveMemberFromTeams(t0) {
  const $ = _c(33);
  const {
    companyId,
    memberId
  } = t0;
  const [shouldShowDialog, setShouldShowDialog] = useState(false);
  const bulkActionName = useAppSelector(bulkActionNameSelector);
  const shouldShowSuccessDialog = useAppSelector(shouldShowSuccessDialogSelector);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = selectedEntitiesSelector("teams");
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const selectedEntities = useAppSelector(t1);
  const dispatch = useAppDispatch();
  const {
    bulkDialogContent,
    successDialogContent
  } = useRemoveMemberFromTeamsBulkDialogContent();
  const mode = useBulkActionsMode();
  let t2;
  let t3;
  if ($[1] !== shouldShowSuccessDialog) {
    t2 = () => {
      if (shouldShowSuccessDialog) {
        setShouldShowDialog(false);
      }
    };
    t3 = [shouldShowSuccessDialog];
    $[1] = shouldShowSuccessDialog;
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  useEffect(t2, t3);
  let t4;
  if ($[4] !== dispatch) {
    t4 = function onRemoveMemberClick() {
      dispatch(setBulkActionName("removeMemberFromTeams"));
      setShouldShowDialog(true);
    };
    $[4] = dispatch;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const onRemoveMemberClick = t4;
  let t5;
  if ($[6] !== mode) {
    t5 = getBulkActionButtonConfig(mode, `Remove member from selected ${TEAM_DISPLAY_NAME}s`);
    $[6] = mode;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const config = t5;
  let t6;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <DeleteIcon sx={{
      width: "18px",
      height: "18px"
    }} />;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== config.shouldShowText) {
    t7 = config.shouldShowText && <Text variant="buttonM">Remove</Text>;
    $[9] = config.shouldShowText;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== config.rippleColor || $[12] !== config.sx || $[13] !== config.tooltipText || $[14] !== onRemoveMemberClick || $[15] !== t7) {
    t8 = <FaroTextButton onClick={onRemoveMemberClick} tooltipText={config.tooltipText} sx={config.sx} rippleColor={config.rippleColor} startIcon={t6}>{t7}</FaroTextButton>;
    $[11] = config.rippleColor;
    $[12] = config.sx;
    $[13] = config.tooltipText;
    $[14] = onRemoveMemberClick;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== bulkActionName || $[18] !== shouldShowSuccessDialog || $[19] !== successDialogContent) {
    t9 = bulkActionName === "removeMemberFromTeams" && shouldShowSuccessDialog && <BulkSuccessDialog dialogContent={successDialogContent} />;
    $[17] = bulkActionName;
    $[18] = shouldShowSuccessDialog;
    $[19] = successDialogContent;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== bulkActionName || $[22] !== bulkDialogContent || $[23] !== companyId || $[24] !== dispatch || $[25] !== memberId || $[26] !== selectedEntities || $[27] !== shouldShowDialog) {
    t10 = bulkActionName === "removeMemberFromTeams" && shouldShowDialog && <FaroBulkDialog dialogContent={bulkDialogContent} onClose={() => setShouldShowDialog(false)} trackingEvent={BulkActionEvents.bulkRemoveMemberFromTeams} bulkActionCallback={team => dispatch(removeMembersFromTeam({
      companyId,
      teamId: team.id,
      memberIds: [memberId]
    })).unwrap()} selectedEntities={selectedEntities} uniqueIdKey="id" tableDataType="teams" dialogVariant="danger" />;
    $[21] = bulkActionName;
    $[22] = bulkDialogContent;
    $[23] = companyId;
    $[24] = dispatch;
    $[25] = memberId;
    $[26] = selectedEntities;
    $[27] = shouldShowDialog;
    $[28] = t10;
  } else {
    t10 = $[28];
  }
  let t11;
  if ($[29] !== t10 || $[30] !== t8 || $[31] !== t9) {
    t11 = <>{t8}{t9}{t10}</>;
    $[29] = t10;
    $[30] = t8;
    $[31] = t9;
    $[32] = t11;
  } else {
    t11 = $[32];
  }
  return t11;
}